// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e8186c80","337":"cbfe7c64","455":"1850d1d2"}[chunkId] + ".chunk.js";
};